const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const JiraTrackerQuery = {
    PERSONAL_WORK_LOG_WEEK: Backofficebff + '/v1/personal-work-log/week',
};

export const JiraTrackerCommand = {
    PERSONAL_WORK_LOG_UPSERT: Backofficebff + '/v1/personal-work-log/upsert',
    PERSONAL_WORK_LOG_DELETE: Backofficebff + '/v1/personal-work-log/delete',
};
